// Event types
export const gtmEventTypes = {
  PCPU_ENTER_POSTCODE: 'PCPU_ENTER_POSTCODE',
}

// Event creators
export const gtmEvents = {
  [gtmEventTypes.PCPU_ENTER_POSTCODE]: ({postcode}) => ({
    type: gtmEventTypes.PCPU_ENTER_POSTCODE,
    event: 'reactjs.event',
    eventID: 'FED-PCPU-001',
    pageCategory: 'Postcode Pop-up',
    pageAction: `Postcode Pop-up - Entered "${postcode}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/postcode-popup-duck.js